/**
 * Central asset manifest for Black Signal.
 */

export const assets = {
    /* ── Sprites / Images ─────────────────────────────────── */
    sprites: [
        // Add sprites here later if needed for preloading
    ],

    /* ── Sound-effects ───────────────────────────────────── */
    sfx: {
        // 'shoot': 'games/black-signal/audio/sfx/shoot.mp3',
    },

    /* ── Music tracks ────────────────────────────────────── */
    music: [
        'games/black-signal/audio/music/Black Signal - Vastness of Unknown.mp3',
    ],
};

export default assets;
